module.exports = "<div class=\"d-flex flex-nowrap align-items-center info-block\"><div class=info-block__img></div><div class=info-block__text ng-bind-html=$ctrl.text></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-info-block/gmc-info-block.component.html
// module id = 536
// module chunks = 31